import { inject, Injectable } from '@angular/core';
import { Mask, DecimalMarker, MaskService } from '../../../lib';
import { BlockParameterType, TemplateSlot } from '../interfaces';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class MaskMapper {
    private maskService = inject(MaskService);
    private translateService = inject(TranslateService);

    public fromSlotToMask(slot: TemplateSlot): Mask {
        if (this.isLimitedTextMask(slot)) {
            return this.getLimitedTextMask(slot);
        }

        if (this.isNumericNoSepatorMask(slot)) {
            return this.getNumericNoSepatorMask(slot);
        }

        if (this.isNumericMask(slot)) {
            return this.getNumericMask(slot);
        }

        return this.getLimitedTextMask(slot);
    }

    public getNumericMask(slot: TemplateSlot): Mask {
        const dataFormat = slot.dataFormat || '6.4';
        const parts = dataFormat.split('.');
        const separatorLimitSource = parts[0];
        const numberOfDecimals = parts.length > 1 ? parts[1] || '0' : '4';
        const separatorLimit = +separatorLimitSource ? new Array(+separatorLimitSource).fill('1', 0, 1).fill('0', 1).join('') : '0';
        const options = {
            suffix: slot.suffixKey,
            prefix: slot.prefixKey,
            // TODO: Take it from Locale it must reflect
            // the currenct country instance data format.
            decimalMarker: DecimalMarker.Coma,
            separatorLimit,
            numberOfDecimals
        };
        return this.maskService.getNumericMask(options);
    }

    private isNumericMask(slot: TemplateSlot): boolean {
        return !!slot.dataFormat?.includes('.') || (!slot.dataFormat && slot.outputParameterType === BlockParameterType.Number);
    }

    private isLimitedTextMask(slot: TemplateSlot): boolean {
        return !!slot.hasOwnProperty('maxLength');
    }

    private getLimitedTextMask(slot: TemplateSlot): Mask {
        const numberOfLetters = slot.maxLength;
        const options = {
            numberOfLetters,
            suffix: slot.suffixKey,
            prefix: slot.prefixKey
        };
        return this.maskService.getLimitedTextMask(options);
    }

    private isNumericNoSepatorMask(slot: TemplateSlot): boolean {
        return !!slot.dataFormat && !slot.dataFormat?.includes('.') && !isNaN(+slot.dataFormat);
    }

    private getNumericNoSepatorMask(slot: TemplateSlot): Mask {
        const numberOfDigits = +slot.dataFormat!;
        const pattern = new Array(numberOfDigits).fill('0').join('');
        const mask = {
            pattern,
            suffix: slot.suffixKey,
            prefix: slot.prefixKey
        };
        return this.maskService.addDefaults(mask);
    }
}
